var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.824 5 .252 1.502A.841.841 0 0 1 0 .874C0 .62.084.411.252.247A.879.879 0 0 1 .893 0c.26 0 .473.082.641.247l4.214 4.125c.092.09.157.187.195.292A.974.974 0 0 1 6 5c0 .12-.02.232-.057.336a.785.785 0 0 1-.195.292L1.534 9.753a.879.879 0 0 1-.64.247.879.879 0 0 1-.642-.247A.841.841 0 0 1 0 9.126c0-.255.084-.464.252-.628L3.824 5Z",
  fill: "currentColor"
})));
export default SvgChevronRight;